import { Search } from 'components/search/Search';
import { ComponentProps, useEffect, useState } from 'react';

export const DebouncedSearch = ({
    value: initialValue,
    onChange,
    debounce = 250,
    ...props
}: {
    value: ComponentProps<typeof Search>['value'];
    onChange: (value: ComponentProps<typeof Search>['value']) => void;
    debounce?: number;
} & ComponentProps<typeof Search>) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value);
        }, debounce);

        return () => clearTimeout(timeout);
    }, [value]);

    return <Search value={value} onChange={value => setValue(value)} {...props} />;
};
